import React from 'react';
import BackButton from '../components/BackButton';
import RecognitionVsExperience from '../components/RecognitionVsExperience';

function RecognitionVsExperiencePage() {
  return (
    <>
      <BackButton />
      <RecognitionVsExperience />
    </>
  );
}

export default RecognitionVsExperiencePage;
